import { useState } from "react";
import { Modal } from "@altek/ui/components/feedback/Modal";
import { TextareaField } from "@altek/ui/components/form/TextField";
import { Button } from "@altek/ui/components/ui/Button";
import { formatCount } from "@altek/ui/lib/format/number";
import { MESSAGE_MAX_LENGTH } from "../api/chat.types";

/**
 * KENDİ MESAJINI DÜZENLE (sohbet-duzeltme 20 Ekim 2026, denetim H5).
 *
 * NEDEN BİR PENCERE, YAZMA KUTUSU DEĞİL. Yazma kutusunu düzenleme kipine almak, o anda yazılmakta
 * olan YENİ mesajın taslağını ya kaybettirir ya da düzenlemenin altına gömerdi; ek düğmesi de
 * düzenlemede anlamsız (sunucu bir mesajın eklerini sonradan değiştirmiyor). Pencere yalnız metni
 * açıyor, kaydedince mesajın altında «düzenlendi» yazıyor. Süre sınırı yok: sunucuda yok.
 *
 * Boş metin ve 8000 karakterin üstü İSTEK ATILMADAN söyleniyor — sunucu ikisini de 400 ile
 * reddediyor ve o ret, düğmeye basan kişiye bir şey anlatmıyordu.
 *
 * Çağıran pencereyi yalnız düzenlenen bir mesaj varken ve o mesajın kimliğini `key` vererek
 * çiziyor: başka bir mesaj kendi metniyle, temiz bir durumla açılıyor.
 */
export function EditMessageModal({
  initialBody,
  isPending,
  onCancel,
  onSave,
}: {
  initialBody: string;
  isPending: boolean;
  onCancel: () => void;
  onSave: (body: string) => void;
}) {
  const [text, setText] = useState(initialBody);

  const trimmed = text.trim();
  const error =
    trimmed === ""
      ? "Mesaj boş olamaz. Silmek için «sil»i kullanın."
      : trimmed.length > MESSAGE_MAX_LENGTH
        ? `Mesaj en çok ${formatCount(MESSAGE_MAX_LENGTH)} karakter olabilir.`
        : null;

  return (
    <Modal
      open
      onOpenChange={(next) => {
        if (!next) onCancel();
      }}
      title="Mesajı düzenle"
      description="Değişiklik sohbetteki herkese görünür; mesajın altında «düzenlendi» yazar."
      isPending={isPending}
      footer={
        <>
          <Button variant="secondary" onClick={onCancel} disabled={isPending}>
            Vazgeç
          </Button>
          <Button
            variant="primary"
            loading={isPending}
            disabled={error !== null}
            {...(error !== null ? { disabledReason: error } : {})}
            onClick={() => onSave(text)}
          >
            Kaydet
          </Button>
        </>
      }
    >
      <TextareaField
        label="Mesaj"
        required
        rows={4}
        value={text}
        maxLength={MESSAGE_MAX_LENGTH}
        onChange={(event) => setText(event.target.value)}
        {...(error !== null && text !== initialBody ? { error } : {})}
      />
    </Modal>
  );
}
